import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import PropTypes from 'prop-types';
import { Radar } from 'react-chartjs-2';
import { BROADSIGHT_PRIMARY_BLUE, withAlpha } from './analyticsColors';
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export function RadarChart({ chartData, title, ref, showTitle = true }) {
  const labels = [];
  const values = [];

  chartData[0].forEach((i) => {
    labels.push(Object.values(i)[0]);
    values.push(Object.values(i)[1]);
  });

  const data = {
    labels: labels,
    datasets: [
      {
        label: title,
        data: values,
        fill: true,
        backgroundColor: withAlpha(BROADSIGHT_PRIMARY_BLUE, 0.24),
        borderColor: BROADSIGHT_PRIMARY_BLUE,
        pointBackgroundColor: BROADSIGHT_PRIMARY_BLUE,
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: BROADSIGHT_PRIMARY_BLUE,
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      title: {
        display: showTitle,
        text: `${title}`,
      },
    },
    maintainAspectRatio: false,
  };

  return <Radar options={options} data={data} ref={ref} />;
}

RadarChart.propTypes = {
  chartData: PropTypes.array,
  title: PropTypes.string,
  ref: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.any,
    }),
  ]),
  showTitle: PropTypes.bool,
};
